import { render, staticRenderFns } from "./BirReport.vue?vue&type=template&id=df0a45ec"
import script from "./BirReport.vue?vue&type=script&lang=js"
export * from "./BirReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports